import React from 'react';
import HotkeySectionLineItem from './line-item';
import { useSellerPresetHotkeys, useCtrlOrCmd } from './hooks';

const SellerPresetHotkeys = () => {
  const ctrlOrCmd = useCtrlOrCmd();
  const presetHotkeys = useSellerPresetHotkeys(ctrlOrCmd);
  return presetHotkeys.map(({ hotkey, name }) => <HotkeySectionLineItem key={hotkey} hotkey={hotkey} name={name} />);
};

export default SellerPresetHotkeys;
